module.exports = __webpack_public_path__ + "10e113642d2e9afc1b0f85751483cf2c.fbx";